const ko = {
    login: {
    title: '데이터 전송 시스템',
    email: '이메일',
    password: '비밀번호',
    forgotPassword: '비밀번호를 잊으셨나요?',
    logout: '로그아웃',
    inEmail: '유효하지 않은 이메일입니다',
    loginfailed: '로그인 실패, 이메일 또는 비밀번호가 잘못되었습니다',
    enterEmail: '이메일을 입력하세요',
    enterPassword: '비밀번호를 입력하세요',
    enterCode: '확인 코드를 입력하세요',
    passwordNotMatch: '비밀번호가 일치하지 않습니다',
    },
    forgot: {
    forgotPassword: '비밀번호를 잊으셨나요?',
    tip: '이메일로 확인 코드를 보내드립니다',
    email: '이메일',
    code: '확인 코드',
    password: '비밀번호',
    confirmPassword: '비밀번호 확인',
    send: '보내기',
    submit: '제출',
    login: '로그인',
    },
    menu: {
    mange: '양식 관리',
    mangeTip: '데이터 전송 양식 생성, 데이터 확인',
    submission: '양식 작성',
    account: '계정 관리',
    uwell: '내부 계정',
    external: '외부 계정',
    },
    editList: {
    fill: '작성',
    record: '데이터',
    createdTime: '작성일',
    formTitle: '양식 제목',
    titleTip: '제목을 입력하세요',
    showInput: '작성된 양식 및 작성 기록 표시',
    },
    editFill: {
    save: '저장하다',
    nosave:'저장하지 않음',
    backSaveTip:'입력한 내용을 저장하시겠습니까? ',
    submitted:'제출됨',
    notsubmitted:'제출되지 않음',

    submit: '전송',
    submitSuccess: '전송이 성공적으로 완료되었습니다',
    fillAgain: '다시 작성',
    invalid: '잘못된 매개변수',
    noTime: '현재 양식을 사용할 수 없습니다',
    failedStop: '전송 실패, 양식이 더 이상 데이터를 받지 않습니다',
    failedNot: '전송 실패, 양식이 존재하지 않습니다',
    failedPassed: '전송 실패, 양식은 한 번만 작성할 수 있습니다',
    failedOnce: '전송 실패, 양식은 하루에 한 번만 작성할 수 있습니다',
    noempty: '필수 입력 필드는 비워둘 수 없습니다',
    },
    editInfo: {
    SubmitTime: '전송 시간',
    submitter:'제출자',
    search: '검색',
    clear: '지우기',
    filter: '필터',
    fieldSetting: '필드 관리',
    export: '내보내기',
    createBy: '작성자',
    updateTime: '업데이트 시간',
    status:'상태',
    action: '동작',
    detail: '세부 정보',
    edit: '편집',
    more:"더",
    copy:"복사",
    startDate: '시작일',
    endDate: '종료일',
    selectAll: '전체 선택',
    confirm: '확인',
    cancel: '취소',
    addFilter: '필터 기준 추가',
    pleaseSelect: '선택하세요',
    pleaseFillIn: '작성해주세요',
    delete: '삭제',
    filterIncom: '행 {num}의 필터 기준이 완전하지 않습니다. 확인해주세요',
    noData: '데이터가 없습니다',
    uploadfailed: '업로드 실패',
    total: '총 {num}개 항목',

    deleteTip: '이 작업은 데이터를 삭제합니다. 계속하시겠습니까?',
    deleteSuccess: '삭제되었습니다'
    },
    fillIn: {
    equal: '같음',
    noequal: '다름',
    contains: '포함',
    notcontains: '미포함',
    empty: '비어 있음',
    notempty: '비어 있지 않음',
    before: '이전',
    after: '이후',
    greaterequal: '이상',
    lessequal: '이하',
    greaterthan: '초과',
    lessthan: '미만',
    },
    editEye: {
    detail: '양식 데이터',
    },
    editUpdate: {
    editForm: '양식 편집',
    returnList: '리스트로 돌아가기',
    },
    };

export default ko;